import { type FC } from 'react'
import { Campaign, SplitForm, SplitType, MTDtracking } from '@shamaazi/mytennights'

const MTDSplit: FC<{ nextPage: string }> = ({ nextPage }) => {
  const splitTypes = [SplitType.Equally, SplitType.MoreArafah]
  const styles = {
    textColor: '',
    initialButtonStyles: 'border border-mtd-blue-1 bg-mtd-secondary-2 text-mtd-h4 text-secondary',
    selectedButtonStyles: 'bg-mtd-blue-1 text-white text-mtd-h4'
  }
  return <SplitForm variant={Campaign.mtd} nextPage={nextPage} splitTypes={splitTypes} styles={styles} tracking={MTDtracking} />
}

export default MTDSplit
